import { useState } from "react";
import "./Testtype.scss";
import ObjectiveSvg from "@Assets/svg/Dashboard-svgs/rightarrow.svg"
import ActiveRightArrowSvg from "@Assets/svg/Dashboard-svgs/ActiveRightArrow.svg"
import ActiveProgressbarSvg from "@Assets/svg/Dashboard-svgs/ActiveProgressivebar.svg";
import ProgressbarSvg from "@Assets/svg/Dashboard-svgs/progressiveBar.svg";
import { useNavigate, useParams } from "react-router-dom";
import { AppRouteURL } from "@Constants/app-route-url.constant";
import { toast } from "react-hot-toast";
import { TestDurationIndex } from "../../TestDuration";
import SvgIcon from '@Components/icons/SvgIcon';


export const TestType = ({ testTypeHandler, durationHandler, isDiagnosticTestSeries, isFullMockTestSeries, isPreviousYearMockTestSeries, onContinueClick }: any) => {
  const params = useParams();
  const navigation = useNavigate();
  const enum testType {
    Regular = 1,
    Speed
  }
  const testId = params.testId;
  const [testtype, setTesttype] = useState(-1);

  const setSelection = (option: number) => {
    setTesttype(option);
    testTypeHandler(option);   // pass selection to parent (MockTestIndex)
  };

  const handleDurationChange = (duration: number) => {
    durationHandler(duration);  // pass duration to parent (MockTestIndex)
  };

  const showRegular = !isDiagnosticTestSeries;
  const showSpeed = !isFullMockTestSeries && !isPreviousYearMockTestSeries;

  const regularTestContent = () => {
    if (isPreviousYearMockTestSeries) {
      return <>
        <li><SvgIcon name="totalChapters" className="list-icon" size={20} />Official Papers</li>
        <li><SvgIcon name="lineChart" className="list-icon" size={20} /> Topicwise Analysis & Difficulty Breakdown</li>
        <li><SvgIcon name="tickCircle" className="list-icon" size={20} /> Detailed Solutions</li>
      </>
    } else if (isFullMockTestSeries) {
      return <>
        <li><SvgIcon name="totalChapters" className="list-icon" size={20} />Real Exam Interface & Exact Pattern</li>
        <li><SvgIcon name="time" className="list-icon" size={20} /> Strict Timing</li>
        <li><SvgIcon name="lineChart" className="list-icon" size={20} /> Detailed Analysis</li>
      </>
    } else {
      return <>
        <li><SvgIcon name="totalChapters" className="list-icon" size={20} /> Chapter-wise + Full tests</li>
        <li><SvgIcon name="lineChart" className="list-icon" size={20} /> Improve accuracy</li>
        <li><SvgIcon name="tickCircle" className="list-icon" size={20} /> Unlimited attempts</li>
      </>
    }
  }
  const regularTestHeadingAndButton=()=>{
    if(isPreviousYearMockTestSeries){
      return {
        heading:"Previous Year Test",
        button:"Start Previous Year Test"
      }
    }else if(isFullMockTestSeries){
      return {
        heading:"Mock Test",
        button:"Start Full Length Mock Test"
      }
    }else{
      return {
        heading:"Practice Smart",
        button:"Improve Accuracy"
      }
    }
  }
  return (
    <>
      <div className="test-content-card" style={{ width: "100%" }}>
        <div className={`type-cards-container ${(!showRegular || !showSpeed) ? 'single-card' : ''}`}>
          {showRegular && (
            <div className="type-card regular-card" style={{ marginTop: 0, cursor: "default" }}>
              <div className="card-main-content" >
                <div className="card-icon-wrapper regular-icon">
                  <SvgIcon name="bookOpen" size={40} />
                </div>
                <div className="card-info">
                  <div className="card-title">{regularTestHeadingAndButton().heading}</div>
                  <div className="card-desc">Build concepts and improve accuracy with structured tests.</div>
                  <ul className="feature-list">
                    {regularTestContent()}
                  </ul>
                </div>
              </div>

              <div className="card-footer-info">
                <div className="badges-row">
                  <span className="card-badge recommendation">⭐ Best for learning phase</span>
                  <span className="card-badge focus">Focus: Concepts & Accuracy</span>
                </div>
                <button className="action-btn btn-regular" onClick={() => { setSelection(testType.Regular); onContinueClick(testType.Regular); }}>
                  {regularTestHeadingAndButton().button} <SvgIcon name="rightArrow" size={18} />
                </button>
              </div>
            </div>
          )}

          {showSpeed && (
            <div className={`type-card ${isDiagnosticTestSeries ? 'diagnostic-card' : 'speed-card'}`} style={{ marginTop: 0, cursor: "default" }}>
              <div className="card-main-content">
                <div className={`card-icon-wrapper ${isDiagnosticTestSeries ? 'diagnostic-icon' : 'speed-icon'}`}>
                  <SvgIcon name="timeSpeed" size={40} />
                </div>
                <div className="card-info">
                  <div className="card-title">{isDiagnosticTestSeries ? "Readiness Check" : "Speed Test"}</div>
                  <div className="card-desc">
                    {isDiagnosticTestSeries
                      ? "Assess your current level and identify areas of improvement."
                      : "Improve speed and time management with short timed tests."}
                  </div>
                  <ul className="feature-list">
                    <li><SvgIcon name="time" className="list-icon" size={20} /> {isDiagnosticTestSeries ? "Time vs Accuracy Analysis" : "Time-bound tests"}</li>
                    <li><SvgIcon name="electricity" className="list-icon" size={20} />{isDiagnosticTestSeries ? "Weak Chapter Identified" : " Faster solving"}</li>
                    <li><SvgIcon name="mockTest" className="list-icon" size={20} />{isDiagnosticTestSeries ? "Personalized Practice Plan" : "Exam pressure simulation"} </li>
                  </ul>
                </div>
              </div>

              <div className="card-footer-info">
                <div className="badges-row">
                  <span className="card-badge speed-rec">🚀 Best for revision phase</span>
                  <span className="card-badge focus">Focus: Speed & Time Management</span>
                </div>

                {!isDiagnosticTestSeries && (
                  <div className="card-duration-selection">
                    <TestDurationIndex durationHandler={handleDurationChange} />
                  </div>
                )}

                <button
                  className={`action-btn ${isDiagnosticTestSeries ? 'btn-diagnostic' : 'btn-speed'}`}
                  onClick={() => {
                    if (isDiagnosticTestSeries) {
                      durationHandler(10);
                      onContinueClick(testType.Speed, 15);
                    } else {
                      onContinueClick(testType.Speed);
                    }
                    setSelection(testType.Speed);
                  }}
                >
                  {isDiagnosticTestSeries ? "Start Readiness Check" : "Boost Speed"} <SvgIcon name="rightArrow" size={18} />
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
